import {
    EXERCISE_CALCULATION,
    EXERCISE_LOGIC,
    EXERCISE_MAGIC_BOX,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_SEQUENCE,
    EXERCISE_TASK
} from '@app/app.constants';

export const TABLE_ROWS_KEY = 'teacherAnalysisTableRows';
export const TABLE_ROWS_NAMES = {
    variantsSolved: 'Решено вариантов',
    tasksSolved: 'Решено заданий',
    // solved: 'Решено одним учеником',
    errors: '% ошибок',
    solveAmount: 'Кол-во решавших',
    success: 'Успешность',
    averageSolveAmount: 'Решено в среднем',
    earned: 'Заработано',
    extra_exercises: 'Доп. задание'
};
export const TABLE_ROWS_KEYS = Object.keys(TABLE_ROWS_NAMES);
export const DEFAULT_TABLE_ROWS = ['tasksSolved', 'errors', 'earned'];

export const TaskTypesArray = [
    EXERCISE_CALCULATION,
    EXERCISE_SEQUENCE,
    EXERCISE_TASK,
    EXERCISE_LOGIC,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_MAGIC_BOX
];

export const TaskTypes = {
    EXERCISE_TASK,
    EXERCISE_LOGIC,
    EXERCISE_CALCULATION,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_MAGIC_BOX,
    EXERCISE_SEQUENCE
};
